import { Component, OnChanges, OnInit, inject } from '@angular/core';

import { DeviceService, RtmsType } from '@frontend/vanilla/core';
import { LhHeaderBarComponent } from '@frontend/vanilla/features/header-bar';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { ImageComponent } from '@frontend/vanilla/shared/image';

import { RtmsCtaActionComponent } from './rtms-cta-action.component';
import { RtmsLayerComponentBase } from './rtms-layer-component-base';
import { RtmsLayerDesktopGamesLockedListComponent } from './rtms-layer-desktop-games-locked-list.component';
import { RtmsLayerDesktopGamesUnlockedListComponent } from './rtms-layer-desktop-games-unlocked-list.component';
import { RtmsLayerMobileGamesLockedListComponent } from './rtms-layer-mobile-games-locked-list.component';
import { RtmsLayerMobileGamesUnlockedListComponent } from './rtms-layer-mobile-games-unlocked-list.component';

@Component({
    imports: [
        TrustAsHtmlPipe,
        ImageComponent,
        RtmsCtaActionComponent,
        LhHeaderBarComponent,
        RtmsLayerMobileGamesLockedListComponent,
        RtmsLayerDesktopGamesLockedListComponent,
        RtmsLayerMobileGamesUnlockedListComponent,
        RtmsLayerDesktopGamesUnlockedListComponent,
        IconCustomComponent,
    ],
    selector: 'lh-rtms-layer-custom-overlay',
    templateUrl: 'rtms-layer-custom-overlay.component.html',
})
export class RtmsLayerCustomOverlayComponent extends RtmsLayerComponentBase implements OnInit, OnChanges {
    deviceService = inject(DeviceService);

    isMobile: boolean;

    override ngOnInit() {
        this.isMobile = this.deviceService.isMobile;
    }

    protected readonly RtmsType = RtmsType;
}
